module.exports = __webpack_public_path__ + "static/monetize-tile-4-4-3d8aafdb9932ec9bd713728299df81c8.png";